import { Component, computed, effect, input, model, ViewChild } from '@angular/core';
import { FilterItemWithLabel } from '@vectronic/util';
import { ChipsFilterComponent } from '../chips-filter/chips-filter.component';
import { FilterHeaderComponent } from '../filter-header/filter-header.component';

@Component({
  selector: 'vectronic-chips-filter-with-header',
  templateUrl: './chips-filter-with-header.component.html',
  styleUrls: ['./chips-filter-with-header.component.scss'],
  imports: [FilterHeaderComponent, ChipsFilterComponent],
})
export class ChipsFilterWithHeaderComponent<T> {
  title = input.required<string>();
  availableFilterItems = input.required<FilterItemWithLabel<T>[]>();
  selectedItems = model<T[]>(undefined);
  disabled = input(false);

  @ViewChild(ChipsFilterComponent) private chipsFilterComponent: ChipsFilterComponent<T>;
  isFilterHidden = model(true);
  selectedFilterItems = computed<FilterItemWithLabel<T>[]>(() => {
    const availableFilterItems = this.availableFilterItems();
    return (
      this.selectedItems()?.map((item) => ({
        item,
        label: availableFilterItems?.find((filterItem) => this.itemsMatch(filterItem.item, item))
          ?.label,
      })) ?? []
    );
  });

  // noinspection JSUnusedGlobalSymbols
  setFilterActiveWhenSelectedItemIsValid = effect(() => {
    if (this.selectedItems()?.length) {
      this.isFilterHidden.set(false);
    }
  });

  // noinspection JSUnusedGlobalSymbols
  focusFilterInputOnShow = effect(() => {
    if (!this.isFilterHidden() && !this.selectedItems()?.length) {
      setTimeout(() => this.chipsFilterComponent?.focusInput());
    }
  });
  toggleFilter() {
    if (this.disabled()) return;

    if (!this.isFilterHidden()) {
      this.selectedItems.set(undefined);
    }
    this.isFilterHidden.update((old) => !old);
  }

  onSelectItem(event: FilterItemWithLabel<T>) {
    if (this.disabled()) return;

    this.selectedItems.update((oldFilter) => {
      if (!oldFilter) {
        return [event.item];
      }
      const newFilter = [...oldFilter];
      newFilter.push(event.item);
      return newFilter;
    });
  }

  onDeleteItem(event: { item: FilterItemWithLabel<T>; index: number }) {
    if (this.disabled()) return;

    this.selectedItems.update((oldFilter) => {
      const newFilter = oldFilter.toSpliced(event.index, 1);
      return newFilter.length === 0 ? undefined : newFilter;
    });
  }

  private itemsMatch(first: T, second: T): boolean {
    if (first === second) {
      return true;
    }
    if (Array.isArray(first) && Array.isArray(second)) {
      return (
        first.length === second.length &&
        first.every((item, index) => this.itemsMatch(item as T, second[index] as T))
      );
    }
    return false;
  }
}
